import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleBase from "../../../../framework/core/mvvm/module_base";
import ChatScroll from "./chat_scroll";
import PlayerChatItem from "./playerChatItem";
import ModelData, { IUserData } from "../../../public/model_data";
import LoaclStorage from "../../../../manager/local_storage";
import TextureManager from "../../../../manager/texture_manager";
import { UITableView, ScrollDirection, ScrollItemData } from "../../../../framework/tools/tableview/UITableView";
import { ChatCell } from "./chat_cell";
import { ListView, ListViewDir, ListItem } from "../../../../framework/tools/scrollview/listview";
import ChatFriendItem from "./chat_friend_item";
import { friend_utils } from "../friend/friend_utils";
import { chat_data } from "./chat_data";
import { Notify } from "../../server/notify/proto_notify";
import AppData from "../../../public/const/app_data";
import Chat from "./chat";
//import FriendTransferCom from "../friend/friend_transfer_com";
import Utility from "../../../../utility/utility";
import ModuleManager from "../../../../framework/core/module_manager";
import FriendTransferModule from "../friend/friend_transfer_module";


const { ccclass, property } = cc._decorator;
export enum ChatType {
    none = 0,
    friendChat = 1,
    friendList = 2,
    worldChat = 3,
    system = 4,
    club = 5,

}
@ccclass
export default class ChatView extends ViewBase {

    @property(ChatScroll)
    chatScroll: ChatScroll = null;

    @property(cc.ScrollView)
    worldScrollView: cc.ScrollView = null;

    @property(cc.Mask)
    chatViewMask: cc.Mask = null;

    @property(cc.Node)
    chatPrefab: cc.Node = null;

    @property(cc.Node)
    privateChatPrefab: cc.Node = null;

    @property(cc.Button)
    sendBtn: cc.Button = null;

    @property(cc.Button)
    hornBtn: cc.Button = null;

    @property(cc.Button)
    quickChatBtn : cc.Button = null; 

    @property(cc.Node)
    quickChatNode : cc.Node = null;

    @property(cc.Node)
    friendInfo : cc.Node = null;

    @property(cc.Node)
    noFriendMsg : cc.Node = null;

    // @property(FriendTransferCom)
    // friendTransfer : FriendTransferCom = null;
    
    @property(cc.Button)
    transferBtn : cc.Button = null;

    @property(cc.EditBox)
    inputTxt: cc.EditBox = null;

    @property(cc.Node)
    worldContent: cc.Node = null;


    @property(cc.Node)
    chatMask: cc.Node = null;

    @property(cc.Node)
    sendNode: cc.Node = null;

    @property(cc.Toggle)
    friendToggle: cc.Toggle = null;

    @property(cc.Toggle)
    worldToggle: cc.Toggle = null;

    @property(cc.ScrollView)
    privateScrolloView: cc.ScrollView = null;

    @property(cc.Mask)
    privateChatViewMask: cc.Mask = null;

    @property(cc.Node)
    privateChatContent: cc.Node = null;

    @property(cc.ScrollView)
    friendListScrollView: cc.ScrollView = null;

    @property(cc.Node)
    friendListContent: cc.Node = null;

    @property(cc.Node)
    friendListViewNode: cc.Node = null;

    @property(cc.Node)
    friendListPrefab: cc.Node = null;

    @property(cc.Node)
    reconnetctBtn : cc.Node = null;

    @property(cc.Node)
    chatParent : cc.Node = null;

    @property(cc.Label)
    hornNumLab : cc.Label = null;

    private friendListView: ListView = null;

    private _curFriendId: number;
    get curFriendId(): number {
        return this._curFriendId;
    }

    private _curFriendData : any;
    get curFriendData() : any {
        return this._curFriendData;
    }

    mWorldTableView: UITableView = null;

    mPrivateTableView: UITableView = null;


    curChatType: ChatType = ChatType.none

    friendList: any[] = []    

    lastChatMap : Map<number,number> = new Map(); 

    quickChatList : string [] = [];

    moveSpeed = 0.2

    friendChatState = {
        chatMaskHeight: 780, //遮罩高
        chatMaskPos: cc.v2(0, -8),//遮罩位置
        chatPanelPos: cc.v2(0, -41),// 聊天窗口位置
        chatContentPos: cc.v2(0, 401), //item父对象位置
        friendPanelPos: cc.v2(-740, -63) //好友列表位置
    }
    friendListState = {
        chatPanelPos: cc.v2(744, -41),
        friendPanelPos: cc.v2(0, -63)
    }
    worldChatState = {
        chatMaskHeight: 880, //遮罩高
        chatMaskPos: cc.v2(0, 35),//遮罩位置
        chatPanelPos: cc.v2(0, -41),// 聊天窗口位置
        chatContentPos: cc.v2(0, 440), //item父对象位置
        friendPanelPos: cc.v2(-740, -63) //好友列表位置
    }
    onLoad() {

        this.eventBind("click_playerChatItem", this.updateFriendChat.bind(this))     
        
        this.quickChatList = [  "หวัดดีทุกคน",
                                "โชคมาแล้วววหยุดไม่ได้แล้ววว",
                                "โทษทีนะชนะหลายรอบละ",
                                "ขอให้เฮงๆนะคะ",
                                "ฝากเนื้อฝากตัวด้วยน๊ะ",
                                "ใจเย็นๆนะ",
                                "รอบนี้จะชนะให้ได้",
                                "ชหรือญอะ",
                                "รีบ！เดี๋ยวเวลาหมด",
                                "ไปละเดี๋ยวมาใหม่",
        ]
        

        this.eventBind("friend_transfer_remain",this.on_friend_transfer_success);

        this.eventBind("buy_item_event",this.on_buy_item_event);

    }

    onShow(){

        this.reconnetctBtn.active = AppData.testMode;
        
    }

    onQuickChat(event,arg){

        let index : number = Number(arg);
        //@ts-ignore
        this._moduleBase.sendToFriend(this.quickChatList[index]);

        this.quickChatNode.active = false;
        
    }

    onClickFirendItem(event) {

        //Utility.playButtonSound();
        let friendItem = event.node.getComponent(ChatFriendItem);

        this.updateFriendChat(friendItem.data);
    }

    updateFriendListView(playerId?: number) {      
        
        if (this.friendListView) {
            this.friendListView.set_data([]);
        }        
        else
        {
        //if(!this.friendListView){
            let list: ListView = new ListView({
                scrollview: this.friendListScrollView,
                view: this.friendListViewNode,
                content: this.friendListContent,
                item_prefab: this.friendListPrefab,
                cb_host: this,
                item_update_func: this.friendListItemUpdate,
                column: 1,
                row: 1,
                gap_y: 1,
                direction: ListViewDir.Vertical,
            });
            this.friendListView = list;
        }

        let self = this;
        console.warn("   updateFriendListView  ");
        friend_utils.reqFriendList(this, (friendList: any[]) => {
            self.showListView(ChatType.friendChat)        
            if (friendList && friendList.length > 0) {
                               
                //比较      
                //将没有的好友 删除掉          
                for (let index = 0; index < self.friendList.length; index++) {
                    const saveData = self.friendList[index];

                    let find = false;   
                    for (let k = 0; k < friendList.length; k++) {
                        const curData = friendList[k];
                        if (curData.friendId == saveData.friendId) {
                            self.friendList[index] = curData;
                            find = true;
                            break;
                        }
                    }
                    //如果没有找到 删除
                    if (!find) {
                        self.friendList.splice(index,1);
                        index--;     
                    }                   
                } 

                //将新增的好友 置顶
                for (let index = friendList.length - 1; index >= 0; index--){
                    const curData = friendList[index];

                    let find = false;
                    for (let k = 0; k < self.friendList.length; k++) {
                        const saveData = self.friendList[k];
                        if (curData.friendId == saveData.friendId) {                            
                            find = true;
                            break;
                        }
                    }           
                    
                    //表示为新增的 置顶
                    if (!find) {                                                
                        self.friendList.splice(0,0,curData);
                    } 
                }

                let showIndex = 0;
                for (let index = 0; index < self.friendList.length; index++) {
                    const data = self.friendList[index];
                    if (data.friendId == playerId) {
                        showIndex = index;
                        break;
                    }
                }
                self.updateFriendChat(self.friendList[showIndex]);
                self.friendListView.set_data(self.friendList);

                self.setChatBtns(true);
                self.refreshTransfer();
                self.friendInfo.active = true;
                self.noFriendMsg.active = false;
                self.quickChatBtn.node.active = true;
                self.friendListView.scroll_to(showIndex);
                
            }else{

                self.setData(ChatType.friendChat, [], this.mPrivateTableView);
                self.friendInfo.active = false;
                self.noFriendMsg.active = true;
                self.setChatBtns(false);
                self.quickChatBtn.node.active = false;
                self.friendList = [];                
            }

            chat_data.saveChatFriend(self.friendList);
        });
    }

    
    /**
     * 聊天好友置顶
     * @param friendId 
     * @param senderIsSelf 发送者是否为自己
     */
    public topFriend(friendId: number,senderIsSelf : boolean= false){
        
        let refreshItem = false;

        if (!this.friendListView || !this.friendListView.items || this.friendListView.items.length == 0) {
            return false;
        }

        let findIndex = 0
        for (let index = 0; index < this.friendListView.items.length; index++) {
            const item = this.friendListView.items[index];
            if (item.data.friendId == friendId) {
                findIndex = index;
                break;
            }
        }

        if (findIndex != 0) {
            refreshItem = this.friendListView.top_item(findIndex);    
            this.friendListView.scroll_to(0);
        }

        if (!senderIsSelf) {         
            let data = this.friendListView.items[0].data;
            data.online = true;
            this.friendListView.refresh_item(0,data); 
            refreshItem  = true;
        }  

        this.friendList = this.friendListView.datas;

        chat_data.saveChatFriend(this.friendList);

        return refreshItem;

    }

    private setChatBtns(state : boolean){

        this.inputTxt.enabled = state;

        this.hornBtn.interactable = state;
        this.hornBtn.enableAutoGrayEffect = true;
        this.sendBtn.interactable = state;
        this.sendBtn.enableAutoGrayEffect = true;
        
    }

    private friendListItemUpdate(item: cc.Node, data: any, index: number, item_intact?: any) {

        let friendItem = item.getComponent(ChatFriendItem);
        friendItem.updateInfo(index, data);

        let tog = item.getComponent(cc.Toggle);

        if (tog.isChecked && friendItem.friendId == this._curFriendId) {
            this.updateFriendChat(friendItem.data);
        }
        tog.isChecked = friendItem.friendId == this._curFriendId    

    }

    //初始化tableview
    initTableView() {

        this.mWorldTableView = new UITableView({
            scrollview: this.worldScrollView,
            mask: this.chatViewMask,
            content: this.worldContent,
            item_templates: [{
                key: 'normal',
                node: this.chatPrefab,
                item_class: ChatCell
            }],
            direction: ScrollDirection.Vertical,
        })

        this.mPrivateTableView = new UITableView({
            scrollview: this.privateScrolloView,
            mask: this.privateChatViewMask,
            content: this.privateChatContent,
            item_templates: [{
                key: 'normal',
                node: this.privateChatPrefab,
                item_class: ChatCell
            }],
            direction: ScrollDirection.Vertical,
        })


    }

    

    setData(type: ChatType, chatMsgList: any[], tableview: UITableView) {
        let chatmsg: ScrollItemData[] = [];
        for (let i = 0; i < chatMsgList.length; i++) {
            let msg = chatMsgList[i];

            let data: ScrollItemData = {
                key: 'normal',
                data: {
                    type: type,
                    data: msg
                },
            }
            chatmsg.push(data);
        }

        tableview.set_data(chatmsg);
        tableview.scroll_to_end();
    }

    appendOne(type: ChatType, chatData: any, tableview: UITableView, isNeedEnd: boolean = false) {
        let data: ScrollItemData = {
            key: 'normal',
            data: {
                type: type,
                data: chatData,
            },
        }
        tableview.append_data(data);
        if (isNeedEnd) {
            tableview.scroll_to_end();
        }
    }

    

    appendArry(type: ChatType, chatMsgList: any[], tableview: UITableView, isNeedEnd: boolean = false) {
        for (let i = 0; i < chatMsgList.length; i++) {
            let msg = chatMsgList[i];
            let data: ScrollItemData = {
                key: 'normal',
                data: {
                    type: type,
                    data: msg,
                },
            }
            tableview.append_data(data);
        }
        if (isNeedEnd) {
            tableview.scroll_to_end();
        }
    }

    
    showWorldChatPanel(isRefresh: boolean = true) {

        console.warn("showWorldChatPanel");
        this.sendNode.active = true
        this.curChatType = ChatType.worldChat;
        this.showListView(this.curChatType)
        
        if (isRefresh) {
            this.setData(ChatType.worldChat, chat_data.worldChatData, this.mWorldTableView);
        }

        this.getHornNum();

        this.worldScrollView.node.active = true;
    
    }

    private on_buy_item_event(){

        this.getHornNum();
    }

    private getHornNum(){

        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "item/getUserItemList?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }

        this.apiHttpGet(requestData, (respone) => {

            let find = false;
            if (respone.data.length > 0) {
                for (let index = 0; index < respone.data.length; index++) {
                    const item = respone.data[index];
                    if (item.itemCode == "LABA_ITEM") {
                        self.updateHornNum(item.itemNum);
                        find = true;
                        break;
                    }
                }
            }

            if (!find) {
                self.updateHornNum(0);
            }     
        });
    }


    updateHornNum(number: Number){
        this.hornNumLab.string =  number.toString();
    }



    showListView(type: ChatType) {
        this.privateScrolloView.node.active = type == ChatType.friendChat;
        this.worldScrollView.node.active = (type == ChatType.system || type == ChatType.worldChat)
        this.friendListScrollView.node.active = type == ChatType.friendChat;

        this.hornBtn.node.active = type == ChatType.worldChat;
        this.quickChatBtn.node.active = type == ChatType.friendChat ;        

        this.setChatBtns(true);
    }
    

    showFriendListPanel(playerId?: number) {

        cc.warn("show friend panel");
        this.curChatType = ChatType.friendList

        // this.sendNode.active = true

        // this.showListView(ChatType.friendChat)

        this.friendList = chat_data.getChatFriend();
        
        this.updateFriendListView(playerId);
    }


    instantiateObj(prefabNode: cc.Node, parnet: cc.Node): cc.Node {
        var node = cc.instantiate(prefabNode)
        node.position = cc.v2(0, 0)
        node.scale = 1
        node.parent = parnet
        return node
    }

    
    updateFriendChat(friendData : any) {
        this._curFriendId = friendData.friendId;
        this._curFriendData = friendData;

        this.chatScroll.curChatFrientData = []
  
        this.setData(ChatType.friendChat, [], this.mPrivateTableView);
        this.curChatType = ChatType.friendChat
        this.filterPlayer(friendData.friendId)
 
        this.sendNode.active = true

        let nameLabel = this.friendInfo.getChildByName("nameLabel").getComponent(cc.Label);
        nameLabel.string = Utility.filterPlayerName(friendData.nickname,10); 

    }

    public transferRemain : number;
    private refreshTransfer(){

        let self = this;
        friend_utils.getTodayRemain((remain)=>{
            self.transferRemain = remain;
            //self.transferBtn.interactable = remain > 0;
            self.setGray(remain <=0, self.transferBtn);
        })
    }

    public transferFriend(currency : number){

        if (this.transferRemain <= 0) {                        
            //判断原因
            friend_utils.showTransferTip();

        }else{
            //this.friendTransfer.show(currency,this.transferRemain,this.curFriendData);

            ModuleManager.instance.showModule(FriendTransferModule,
                {currency:currency,
                transferRemain:this.transferRemain,
                friendData : this.curFriendData});
        }
    }

    private on_friend_transfer_success(remain){

        this.transferRemain = remain;
        this.setGray(remain <=0, this.transferBtn);
        //this.transferBtn.interactable = remain > 0;
    }

    private setGray(state : boolean, button : cc.Button){

        if (state) {

            button.normalColor = new cc.Color(200,200,200,255);   
            button.hoverColor = new cc.Color(200,200,200,255);   
            button.pressedColor = new cc.Color(200,200,200,255);    
            button.disabledColor = new cc.Color(200,200,200,255);    

        }else{

            button.normalColor = new cc.Color(255,255,255,255);
            button.hoverColor = new cc.Color(255,255,255,255);   
            button.pressedColor = new cc.Color(255,255,255,255);    
            button.disabledColor = new cc.Color(255,255,255,255);   
        } 
    }



    filterPlayer(otherId: number) {
        //let otherId=this.getOhterPlayerId(sendId,revId)

        for (let i = 0; i < this.chatScroll.allFriendChatData.length; i++) {

            if (this.chatScroll.allFriendChatData[i].sendUserId == otherId || this.chatScroll.allFriendChatData[i].recverUserId == otherId) {
                this.chatScroll.curChatFrientData.push(this.chatScroll.allFriendChatData[i])
                this.appendOne(ChatType.friendChat, this.chatScroll.allFriendChatData[i], this.mPrivateTableView, true);                              
            }
        }

    }
    getOhterPlayerId(sendId, revId): number {
        let playerId = 0
        if (ModelData.instance.roleData.id == sendId) {
            playerId = revId
        }
        else {
            playerId = sendId
        }
        return Number(playerId);
    }
    // update (dt) {}
}
